import { h } from 'preact'
import { useState } from 'preact/hooks'

export const MentionsLegales = ({ title = 'Conditions', description, notes, cacheKey }) => {
   const [isOpened, setIsOpened] = useState(false)

   const toggleExpanded = () => {
      setIsOpened(!isOpened)
   }
   return (
      <div id="zone_legal_notices" class="mentions-legales bg-gray2 legal-notices" data-testid="bande-mentions-legales" data-cache-key={cacheKey}>
         <div class="container-fluid">
            <div class="row no-gutters py-1 text-black">
               <details class="col-12" onClick={() => toggleExpanded()}>
                  <summary role="button" aria-controls="details-mentions" aria-expanded={isOpened}>
                     <h2 class="lead font-weight-bold no-signature mb-0">{title}</h2>
                     <span class="icone-arrow-next" aria-hidden="true" />
                  </summary>
                  {description && <span class="small font-weight-bold d-block">{description}</span>}
                  <ul id="details-mentions" class="m-0 my-1 list-unstyled">
                     {notes.map((note) => {
                        return (
                           <li class="small">
                              <strong>{note.title}</strong>
                              {note.description && <span> : {note.description}</span>}
                           </li>
                        )
                     })}
                  </ul>
               </details>
            </div>
         </div>
      </div>
   )
}
